class Auth

{
    constructor()
    {

    }

}

new Auth();
